import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const ProjectManagerContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})
